export default __webpack_public_path__ + "static/media/52_1_3.9601a9de.png";